(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('global-security-policy', {
            parent: 'entity',
            url: '/global-security-policy',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            ncyBreadcrumb: {
                label: '{{ "global.menu.security.manageglobalsecuritypolicy" | translate }}',
                parent: 'home'
              },
            views: {
                'content@': {
                    templateUrl: 'app/entities/global-security-policy/global-security-policy.html',
                    controller: 'GlobalSecurityPolicyController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('error');
                    $translatePartialLoader.addPart('global');
                    $translatePartialLoader.addPart('globalSecurityPolicy');
                    return $translate.refresh();
                }]
               
            }
        })
        .state('global-security-policy.new', {
            parent: 'global-security-policy',
            url: '/global-security-policy/{id}/{orgTypeId}/{custUserTypeId}',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$rootScope', '$uibModal', function($stateParams, $state, $rootScope, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-security-policy/global-security-policy-dialog.html',
                    controller: 'GlobalSecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: ['GlobalSecurityPolicy', 'GlobalValues', function(GlobalSecurityPolicy, GlobalValues) {
                            return GlobalSecurityPolicy.get({orgId:GlobalValues.getOrgId(), themeID : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                	$rootScope.$emit('gatewayApp:globalSecurityPolicyRefresh');
                    $state.go('global-security-policy');
                }, function() {
                    $state.go('global-security-policy');
                });
            }]
        })
         .state('global-security-policy-todolist', {
            parent: 'dashboard',
            url: '/global-security-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-security-policy/global-security-policy-dialog.html',
                    controller: 'GlobalSecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('global-security-policy', null, { reload: 'global-security-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('global-security-policy-todolist.resubmit', {
            parent: 'dashboard',
            url: '/global-security-policy-resubmit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-security-policy/global-security-policy-dialog.html',
                    controller: 'GlobalSecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                      entity: function () {                        	

                        }
                    }
                }).result.then(function() {
                    $state.go('global-security-policy', null, { reload: 'global-security-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
        })
        .state('global-security-policy-auditLog', {
            parent: 'audit-log',
            url: '/global-security-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-security-policy/global-security-policy-dialog.html',
                    controller: 'GlobalSecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('global-security-policy', null, { reload: 'global-security-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
        .state('global-security-policy-historyReport', {
            parent: 'history-report',
            url: '/global-security-policy-view',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'global.title'
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/global-security-policy/global-security-policy-dialog.html',
                    controller: 'GlobalSecurityPolicyDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'sm',
                    resolve: {
                    	entity: function () {                        	
                            return {
                            		
                            };
                        }
                    }
                }).result.then(function() {
                	$state.go('global-security-policy', null, { reload: 'global-security-policy' });
                }, function() {
                	$state.go('^');
                });
            }]
            
        })
   };
})();